export default __webpack_public_path__ + "static/media/artwork-card-6.02354205.png";